<style>
.infoMessage{
  color:red;
}
</style>



<app-campaign-3-breadcrumb #breadcrumbComponent [arrayBreadcrumbs]="breadcrumbs"
 homeLink=""  (onClickBreadcrumb)="breadcrumbClicked($event)">
</app-campaign-3-breadcrumb>

<form *ngIf=" fields && form" [formGroup]="form" (submit)="checkActiveAcm()" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title" *ngIf="!editMode">{{ 'acm.add_title' | translate}}</h1>
        <h1 class="step-title" *ngIf="editMode">{{ 'acm.edit_title' | translate}}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty3/acm" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="checkActiveAcm()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
      </div>
    </div>
    <div class="card">
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.acm_code.nullable}">{{ fields.acm_code.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="acm_code"/>
          <!-- MESSAGGIO DI ERRORE -->
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.acm_code"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.channel_id.nullable}">{{ fields.channel_id.keyName }}</span>
          <p-dropdown [options]="listChannel" formControlName="channel_id"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.channel_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.acm_type_id.nullable}">{{ fields.acm_type_id.keyName }}</span>
          <p-dropdown [options]="listAcmType" formControlName="acm_type_id"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.acm_type_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="description"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.description"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.short_descr.nullable}">{{ fields.short_descr.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="short_descr"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.short_descr"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.host_code.nullable}">{{ fields.host_code.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="host_code"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.host_code"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.date_start.nullable}">{{ fields.date_start.keyName }}</span>
          <app-kv-calendar
          #dateStartField
          [inputName]="'date_start'"
          [formData]="form"
          [startDateSelector]="true"
          [endDateInputName]="'date_end'"
          [endDateCalendar]="dateEndField"
          [defaultDate]="defaultStartDate"
          [defaultValue]="defaultStartDate"         
          >
          </app-kv-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.date_start"></app-validation-msg>
          <span class="input-error-notification" *ngIf="dateStartIssue">{{ 'common.startDateLimit' | translate }}</span>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.date_end.nullable}">{{ fields.date_end.keyName }}</span>
          <app-kv-calendar
          #dateEndField
          [inputName]="'date_end'"
          [formData]="form"
          [endDateSelector]="true"
          [startDateInputName]="'date_start'"
          [startDateCalendar]="defaultStartDate"
          [defaultDate]="defaultEndDate"
          [defaultValue]="defaultEndDate">
          </app-kv-calendar>
          <span class="input-error-notification" *ngIf="dateEndIssue">{{ 'common.endDateLimit' | translate }}</span>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.date_end"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.flg_visible.nullable }">{{ fields.flg_visible.keyName }}</span>
          <p-inputSwitch formControlName="flg_visible"></p-inputSwitch>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.flg_visible"></app-validation-msg>
      </div>

      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ fields.date_pti_start.keyName }}</span>
        <app-kv-calendar
        #datePtiStartField
        [inputName]="'date_pti_start'"
        [formData]="form"
        [startDateSelector]="true"
        [endDateInputName]="'date_pti_end'"
        [endDateCalendar]="datePtiEndField"
        [defaultDate]="defaultPtiStartDate"
        [defaultValue]="defaultPtiStartDate">
        </app-kv-calendar>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.date_pti_start"></app-validation-msg>
        <span class="input-error-notification" *ngIf="dateStartIssue">{{ 'common.startDateLimit' | translate }}</span>
      </div>

      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ fields.date_pti_end.keyName }}</span>
        <app-kv-calendar
        #datePtiEndField
        [inputName]="'date_pti_end'"
        [formData]="form"
        [endDateSelector]="true"
        [startDateInputName]="'date_pti_start'"
        [startDateCalendar]="datePtiStartField"
        [defaultDate]="defaultPtiEndDate"
        [defaultValue]="defaultPtiEndDate">
        </app-kv-calendar>
        <span class="input-error-notification" *ngIf="dateEndIssue">{{ 'common.endDateLimit' | translate }}</span>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.date_pti_end"></app-validation-msg>
      </div>
      
      </div>


      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>
      <h3 class="title">{{ fields.num_panel  | translate }}</h3>
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.oper_max_num_pid.nullable}">{{ fields.oper_max_num_pid.keyName }}</span>
          <p-dropdown [options]="listAcmOperatorType" formControlName="oper_max_num_pid"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.oper_max_num_pid"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.max_num.nullable}">{{ fields.max_num.keyName }}</span>
          <input type="number" max="5" pInputText  class="fieldInput" formControlName="max_num"/>
          <span class="input-error-notification" *ngIf="form.controls.max_num.errors?.integerNotNegative">Solo valori interi positivi</span>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [arrayValidators]="[validators.integerNotNegative]" [validation]="fields.max_num"></app-validation-msg>
        </div>

      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>

      <h3 class="title">{{ fields.soglia_panel | translate}}</h3>
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.oper_max_value_pid.nullable}">{{ fields.oper_max_value_pid.keyName }}</span>
          <p-dropdown [options]="listAcmOperatorType" formControlName="oper_max_value_pid"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.oper_max_value_pid"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.max_value.nullable}">{{ fields.max_value.keyName }}</span>
          <input type="number" min="0" step="0.01" pInputText class="fieldInput" formControlName="max_value"/>
          <span class="input-error-notification" *ngIf="form.controls.max_value.errors?.decimalNotNegative">Solo valori decimali positivi</span>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [arrayValidators]="[validators.decimalNotNegative]" [validation]="fields.max_value"></app-validation-msg>
        </div>

      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>

      <h3 class="title">{{ fields.panelsuperamento_volte  | translate}}</h3>
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.oper_trigger_num_pid.nullable}">{{ fields.oper_trigger_num_pid.keyName }}</span>
          <p-dropdown [options]="listAcmOperTrigger" formControlName="oper_trigger_num_pid"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.oper_trigger_num_pid"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.def_num.nullable}">{{ fields.def_num.keyName }}</span>
          <input type="number" class="fieldInput" pInputText formControlName="def_num" [readonly]="!searchLabel(form.get('oper_trigger_num_pid').value, 'DEF', listAcmOperTrigger)"/>
          <span class="input-error-notification" *ngIf="form.controls.def_num.errors?.integerNotNegative">Solo valori interi positivi</span>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [arrayValidators]="[validators.integerNotNegative]" [validation]="fields.def_num"></app-validation-msg>
        </div>

      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>

      <h3 class="title">{{ fields.panel_superamento_soglia  | translate}}</h3>
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.oper_trigger_value_pid.nullable}">{{ fields.oper_trigger_value_pid.keyName }}</span>
          <p-dropdown [options]="listAcmOperTrigger" formControlName="oper_trigger_value_pid"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.oper_trigger_value_pid"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.def_value.nullable}">{{ fields.def_value.keyName }}</span>
          <input type="number" min="0" pInputText step="0.01" class="fieldInput" formControlName="def_value" [readonly]="!searchLabel(form.get('oper_trigger_value_pid').value, 'DEF', listAcmOperTrigger)"/>
          <span class="input-error-notification" *ngIf="form.controls.def_value.errors?.decimalNotNegative">Solo valori decimali positivi</span>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [arrayValidators]="[validators.decimalNotNegative]" [validation]="fields.def_value"></app-validation-msg>
        </div>

      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>

      <h3 class="title">{{ fields.panel_reset  | translate}}</h3>
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.flg_periodic_reset.nullable}">{{ fields.flg_periodic_reset.keyName }}</span>
          <p-inputSwitch formControlName="flg_periodic_reset"></p-inputSwitch>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.flg_periodic_reset"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.period_reset_pid.nullable}">{{ fields.period_reset_pid.keyName }}</span>
          <p-dropdown [options]="listAcmResetTrigger" formControlName="period_reset_pid" [disabled]="!form.get('flg_periodic_reset').value" (onChange)="checkResetPeriod($event)"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.period_reset_pid"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.value_period_pid.nullable}">{{ fields.value_period_pid.keyName }}</span>
          <p-dropdown [options]="listDayOfWeek" formControlName="value_period_pid" [disabled]="!searchLabel(form.get('period_reset_pid').value, 'WEEK', listAcmResetTrigger)"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.value_period_pid"></app-validation-msg>
        </div>

      </div>

      <div class="infoMessage" *ngIf="show.infoMessage">
        <br />
        {{'common.toSaveMessage' | translate}}
        <br />
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>

      <h3 class="title" *ngIf="show.addButton && editMode">{{ fields.panel_layout | translate }}</h3>
      <div class="ui-g ui-fluid" *ngIf="show.addButton && editMode">
        <div class="ui-g-12 ui-md-2">
          <button pButton type="button" icon="fa fa-plus-circle" label="Add Layout" iconPos="left" (click)="showAddOrEditDialog(null,null)" class="k-generic-btn" ></button>
        </div>
      </div>

      <div>
        <div class="ui-g ui-fluid" *ngFor="let layout of listSelectedAcmLayouts; let i=index">
          <p-panel class="ui-g-12" [ngClass]="{'k-opacity': layout.flg_state == '1'}">
            <p-header>
              <div class="ui-helper-clearfix">
                <button pButton type="button" style="cursor:pointer" *ngIf="layout.flg_state == '0'" icon="fa fa-times" (click)="deleteLayout(i)" class="ui-button-danger btnDelete"></button>
                <button pButton type="button" style="cursor:pointer" *ngIf="layout.flg_state == '1'" icon="fa fa-arrow-up" (click)="recoverLayout(i)" class="ui-state-default btnRecover"></button>
                <button pButton type="button" style="cursor:pointer; margin-right: 5px;" *ngIf="layout.flg_state == '0'" icon="fa fa-edit" (click)="editLayout(i)" class="ui-state-default btnEdit"></button>
              </div>
            </p-header>

            <div class="ui-g-12  ui-fluid">
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !fieldsLayout.layout_id.nullable}">{{ fieldsLayout.layout_id.keyName }}</span>
                {{layout.layout_description}}
              </div>

              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !fieldsLayout.description_fe.nullable}">{{ fieldsLayout.description_fe.keyName }}</span>
                {{layout.description_fe}}
              </div>

              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !fieldsLayout.format_string.nullable}">{{ fieldsLayout.format_string.keyName }}</span>
                {{layout.format_string}}
              </div>
            </div>

            <p-footer class="clearfix">&nbsp;</p-footer>
          </p-panel>
        </div>
      </div>

    </div>
  </div>
</form>

<p-dialog *ngIf="show.dialog"
          [width]="500"
          [(visible)]="show.dialog"
          showEffect="fade"
          [modal]="true"
          (onHide)="closeDialog()">

    <loyalty-layout3-form
      [layoutObj]="currentLayout"
      [layoutList]="listAcmLayout"
      (layoutAdded)="layoutAdded($event)"
      (layoutUpdated)="layoutUpdated($event)">
    </loyalty-layout3-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/form-acm-loyalty-3/form-acm-loyalty-3.component.html